module.exports = __webpack_public_path__ + "static/media/release.notes.e9a1cbdc.md";